module.exports = __webpack_public_path__ + "img/church_in_seattle.4dce904a.png";